import { getAxiosClient } from "../../axios-client";
import { OrderAddRequestBody, OrderAddResponse } from "./types";

const axiosClient = getAxiosClient();
export const ordersAdd = async (body: OrderAddRequestBody) => {
  return await axiosClient.ax.post<OrderAddResponse>("/Orders/OrdersAdd", body);
};
